export default {
    indicator: 'indicator',
    chatsList:'chatsList',
    chat: 'chat',
    available: 'available',
    createChat: 'createChat'
}